import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref, onMounted } from 'vue';
import PortalSectionHeader from '@/components/portalSection/portal-section-header.vue';
import LinkButton from '@/components/link-button.vue';
import { useRepositories } from '@/plugins/repositories';
import { useTelemetry } from '@/plugins/telemetry';
export default /*#__PURE__*/_defineComponent({
  __name: 'format-categories-section',
  setup: function setup(__props) {
    var categories = ref([]);
    var route = useRoute();
    var $repositories = useRepositories();
    var $telemetry = useTelemetry();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return $repositories.format.getCategories();
          case 2:
            categories.value = _context.sent;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    function onClick(category) {
      $telemetry.sendClickTelemetry({
        button: 'format-categories-section__item',
        params: {
          format: {
            category: category
          }
        }
      }, route);
    }
    return {
      __sfc: true,
      categories: categories,
      route: route,
      $repositories: $repositories,
      $telemetry: $telemetry,
      onClick: onClick,
      PortalSectionHeader: PortalSectionHeader,
      LinkButton: LinkButton
    };
  }
});